/** 控制台 · 推荐返佣页（pages/console/referrals.tsx）。 */
const messages = {
  'page.title': '推荐返佣',
  'page.description':
    '把推荐码或链接分享给朋友。好友注册时填写你的推荐码后，其任务结算会按比例为你计提返佣，由运营定期结算为额度或线下支付。',

  'status.clawback': '退款冲回',
  copy: '复制',
  copied: '已复制',
  copyAria: '复制{label}',

  'tier.paused': '推荐返佣暂停中，暂停期间不产生新的返佣。',
  'tier.none': '当前没有返佣比例。',
  'tier.item': '第 {month} 个月 {pct}%',
  'tier.separator': '，',
  'tier.text': '好友注册后，按其消费产生的平台毛利返佣：{tiers}；之后不再返佣。',

  'summary.loadError': '推荐信息加载失败',
  'summary.referees': '已推荐用户',
  'summary.accrued': '待结算 · {currency}',
  'summary.settled': '已结算 · {currency}',
  'summary.codeAria': '我的推荐码',
  'summary.code': '我的推荐码',
  'summary.link': '推荐链接',

  'list.title': '返佣记录',
  'list.loaded': '第 {page} 页 · 本页 {n} 条',
  'list.loading': '正在加载…',
  'list.loadError': '返佣记录加载失败',
  'list.empty': '还没有返佣记录。好友用你的推荐码注册并完成任务后，每笔返佣会出现在这里。',
  'list.monthPct': '第 {month} 个月 · {pct}%',

  'table.time': '时间',
  'table.referee': '好友',
  'table.monthPct': '月份 · 比例',
  'table.amount': '返佣',
  'table.status': '状态',
  'table.settledAt': '结算时间',
};

export default messages;
